<template>
	<v-container fluid>
		<v-card elevation="0" class="height-100">
			<v-card-title style="height: 72px">
				<v-btn @click="retreat" color="blue" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
				资质详情
				<v-spacer />
			</v-card-title>
			<v-divider />
			<v-card-text class="pb-0">
				<v-list-item class="pl-2 pr-0">
					<v-list-item-avatar size="56" class="rounded">
						<v-img class="rounded-lg mx-auto" :src="roleView.projIcon" max-height="140" max-width="140"></v-img>
					</v-list-item-avatar>
					<v-list-item-content>
						<v-list-item-title>{{ roleView.projName }}</v-list-item-title>
						<div>
							<div class="grey--text caption mb-1 mt-1 d-inline-block vtk-v-align-middle" style="max-width: 700px" :class="textShow && 'text-overflow'">
								资质介绍：{{ roleView.projNote }}<a v-if="!textShow" @click="textShow = !textShow" class="d-inline-block caption vtk-v-align-middle">{{ textShow ? "展开" : "收起" }}</a>
							</div>
							<a v-if="textShow" @click="textShow = !textShow" class="d-inline-block caption vtk-v-align-middle">{{ textShow ? "展开" : "收起" }}</a>
						</div>
					</v-list-item-content>
					<v-list-item-action>
						<v-btn @click="add" class="success float-right mt-n8" elevation="0"><v-icon>mdi-plus</v-icon>申请资质</v-btn>
					</v-list-item-action>
				</v-list-item>
				<v-tabs>
					<v-tab :to="`/dept-roles?pid=${$route.query.pid}`">已有资质</v-tab>
					<v-tab :to="`/dept-ureg?pid=${$route.query.pid}`"><v-badge dot color="pink">申请记录 </v-badge></v-tab>
				</v-tabs>
			</v-card-text>
		</v-card>
		<dept-input ref="Madd" />
		<keep-alive>
			<router-view style="min-height: calc(100vh - 322px)" />
		</keep-alive>
	</v-container>
</template>

<script>
import Request from "@/commons/request";
// import Storage from "@/commons/storage";
// import Message from "@/components/message";
import DeptInput from "./dept-input";
export default {
	name: "DashUrole",
	components: { DeptInput },
	data() {
		return {
			// 资质详情
			roleView: {},
			textShow: true,
		};
	},
	activated() {
		this.view(this.$route.query.pid);
	},
	methods: {
		// 1.1目录资质详情
		view(id) {
			Request.getForm("/app/abiz/view", { id }).then((res) => {
				this.roleView = res.data;
			});
		},
		// 申请资质
		add() {
			this.$refs.Madd.add();
		},
		retreat() {
			this.$router.push("/dept-page");
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep {
	td.text-start:nth-child(1) {
		padding: 0 !important;
		max-width: 300px;
		width: 300px;
	}
	.v-input__prepend-outer {
		display: none;
	}
	.v-banner__wrapper {
		padding-left: 8px;
	}
	.v-stepper__header {
		height: 56px;
	}
	.v-stepper__step {
		padding-top: 0;
		padding-bottom: 0;
	}
}
</style>
